import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { MmAlertModule } from '@metromarkets/components';

import { CartModule } from '~shared/modules/cart/cart.module';
import { SHOPPING_CART_FEATURE_ID } from './constants/shopping-cart.constants';
import { reducer } from './store/shopping-cart.reducer';
import { ShoppingCartEffects } from './store/shopping-cart.effects';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    StoreModule.forFeature(SHOPPING_CART_FEATURE_ID, reducer),
    EffectsModule.forFeature([ShoppingCartEffects]),
    CartModule,
    MmAlertModule,
  ]
})
export class ShoppingCartStoreModule {
}
